__turbopack_context__.v({
  "artwork": "GaJ_IW_artwork",
  "artworkImage": "GaJ_IW_artworkImage",
  "artworkThumbnail": "GaJ_IW_artworkThumbnail",
  "crdImageWrapper": "GaJ_IW_crdImageWrapper",
  "credits": "GaJ_IW_credits",
  "descriptionTitle": "GaJ_IW_descriptionTitle",
  "descriptionWrapper": "GaJ_IW_descriptionWrapper",
  "mainWrapper": "GaJ_IW_mainWrapper",
  "noImageSvg": "GaJ_IW_noImageSvg",
  "playerWrapper": "GaJ_IW_playerWrapper",
  "sponsorLogo": "GaJ_IW_sponsorLogo",
});
